export default __webpack_public_path__ + "static/media/warning.45ecd26533deede83d922b5db0c47370.svg";